import { render, staticRenderFns } from "./novo.vue?vue&type=template&id=65bc33d6&"
import script from "./novo.vue?vue&type=script&lang=ts&"
export * from "./novo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports